webpackJsonp([244606445029719],{

/***/ 360:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulPage":{"title":"Rum","slug":"rum","metaDescription":null,"body":{"childMarkdownRemark":{"html":"<p>Aston Villa hotell har enkel-, dubbel – och trippelrum, samt två B&#x26;B-rum. Alla våra rum har toalett och dusch, DUX-sängar, TV, kylskåp, hårtork\noch morgonrock.</p>\n<p>En enklare frukostbuffé ingår.</p>\n<p>På hotellet finns gratis wifi och fri parkering i mån av plats.</p>\n<p><img src=\"//images.ctfassets.net/rd75ulqhnmj0/5HIsrfL8XoZzkr5ZZle66Q/cd0aaf9f336a6fdba0912df630c1b4b9/rum_11_s__ng.jpg\" alt=\"Enkelrum\"></p>\n<p><img src=\"//images.ctfassets.net/rd75ulqhnmj0/3PRSLch3MjxndTn8czMWAY/02da0d6957ad4387bdbe594cdfebeb4a/rum_4_s__ngar.jpg\" alt=\"Dubbelrum\"></p>","excerpt":"Aston Villa hotell har enkel-, dubbel – och trippelrum, samt två B&B-rum. Alla våra rum har toalett och dusch, DUX-sängar, TV, kylskåp, hårtork\noch morgonrock. En enklare frukostbuffé ingår. På hotellet finns gratis wifi och fri parkering i mån av plats."}}}},"pathContext":{"slug":"rum"}}

/***/ })

});


// WEBPACK FOOTER //
// path---rum-a2c97a8d7d1db00e24df.js